
import TableList from "@components/templates/tablelist";
// import compUpdate from "./update.vue";
import {
    HttpLimitTakeupList,
    HttpLimitWarehouseList
} from "@/service/setting.js";
import { mapState, mapGetters } from "vuex";
// import mixin from '../mixin';
export default {
    mixins: [TableList],
    // components: {
    //     compUpdate,
    // },
    data () {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            Plugins: { show: true },
            limitwarehouselist: [],
        };
    },
    created () {
        HttpLimitWarehouseList().then(res => {
            this.limitwarehouselist = res.data
        })
    },
    methods: {
        ajaxRequest: HttpLimitTakeupList,
        exportQuery () {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/handelAbility/exportInventory", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
            }
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAll",
            "getWarehouseList",
            "getSelfmanageorgList",
            "getAlllogProCodeList"
        ]),
        ToolsData () {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.blacklist.export'),
                    theme: 'success'
                }
            ]
        },
        SearchsData () {
            return [
                {
                    label: this.$t('fbb.alloment.date', { defaultValue: "日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_capacityDate',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'Select',
                    options: this.limitwarehouselist.map(item => {
                        return {
                            label: item.code + '(' + item.title + ')',
                            value: item.code
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: 'IN_organizationId',
                    show: true,
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    tag: 'Input',
                    key: 'CN_carrierCode',
                },
                {
                    label: 'SKU',
                    tag: 'Input',
                    key: 'CN_erpsku',
                }
            ]
        },
        columns () {
            return [
                {
                    title: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    render: (h, { row }) => {
                        let clientItem = this.getSelfmanageorgList.filter(item => {
                            return row.organizationId === item.value
                        })[0];
                        return <div>{clientItem ? clientItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode'
                },
                {
                    title: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    key: 'carrierCode',
                },
                {
                    title: 'SKU',
                    key: 'erpsku',
                },
                {
                    title: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                },
                {
                    title: this.$t('fbb.alloment.date', { defaultValue: "日期" }),
                    key: 'capacityDate',
                },
                {
                    title: this.$t('', { defaultValue: "占用数量" }),
                    key: 'qtyRequest',
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }
            ];
        },

    }

};
